import React from 'react';
import { Tag } from 'antd';
import { StyledEventTitle } from './styled';

const EventNavTitle = ({ eventId }: { eventId: string }) => {
  return (
    <StyledEventTitle>
      <Tag color="#0f93f5">Event</Tag>
      <span>{eventId || 'Deleted Event'}</span>
    </StyledEventTitle>
  );
};

export default EventNavTitle;
